import React, { FC } from 'react';

import { Box, BoxProps } from '@mantine/core';

import cx from './YouTubeVideo.module.scss';

type Props = BoxProps & {
    url: string;
    width: number;
    height: number;
};

const YouTubeVideo: FC<Props> = ({ url, width, height, ...props }) => {
    const getYouTubeVideoId = (urlOrId: string): string => {
        const patterns = [
            /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
            /youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/,
        ];

        for (const pattern of patterns) {
            const match = urlOrId.match(pattern);
            if (match) {
                return match[1];
            }
        }

        return urlOrId;
    };

    const videoId = getYouTubeVideoId(url);

    return (
        <Box className={cx.youtubeContainer} {...props}>
            <iframe
                src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&iv_load_policy=3&rel=0&playsinline=1`}
                allow="autoplay; encrypted-media"
                className={cx.youtubeFrame}
                style={{
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />
        </Box>
    );
};

export { YouTubeVideo };
